import { MATCH_PAGE_VISITED } from "../BettingConfig";

export const matchPageVisit = (payload: any) => ({
  type: MATCH_PAGE_VISITED,
  payload,
});
